module.exports = __webpack_public_path__ + "static/media/plan-TH4-mobile-tc.a43faf48.png";